import { createAPIActions } from 'barnyard/utils';
import moment from 'moment';

export const NAME = 'dashboard';

export const DASHBOARD_FETCH = createAPIActions(`${NAME}/DASHBOARD_FETCH`);

// Default date range to be used in the corporate analytics dashboard
export const DEFAULT_DATE_RANGE = {
  startDate: moment().subtract(5, 'hours').subtract(30, 'day').format('YYYY-MM-DD'),
  endDate: moment().subtract(5, 'hours').format('YYYY-MM-DD')
};
